import cs from 'classnames'
import { nl2br } from 'helpers'
import Autolinker from 'autolinker'
import { NavLink } from 'react-router-dom'

import './style.css'

const Process = ({process, ...props}) => (
    <div className={cs(
        'process-list__process',
        'process',
        { 'process_public': process.isPublic }
    )}>
        <div className="process__header">
            <h4 className="process__title">
                {process.title}
            </h4>
            {!!process.telegramMessageCount && (
                <div className="process__stat" data-tooltip="Сообщений в день (статистика за последнюю неделю)">
                    <span className="fa fa-fire" />
                    <small>{Number((process.telegramMessageCount / 7).toFixed(1))}</small>
                </div>
            )}
        </div>
        {process?.viewerList && (
            <div className="process__viewer-list">
                Участники: {process?.viewerList.map( viewer => (
                    <span
                        key={process.id + '-' + viewer.id}
                        className={cs(
                            "process__viewer",
                            { "process__admin": process?.adminList.filter(el => el.id === viewer.id).length }
                        )}
                        data-tooltip={
                            process?.adminList.filter(el => el.id === viewer.id).length
                                ? viewer.name + ' ' + viewer.surname + ' — администратор этого процесса'
                                : ""
                        }
                    >
                        {viewer.name} {viewer.surname}
                    </span>
                ))}
            </div>
        )}
        <div className="process__sublink">
            {!!process.telegramChannelId && (<NavLink to={`/process/${process.id}/news`}>Новости процесса</NavLink>)}
            <NavLink to={`/process/${process.id}/events`}>События процесса</NavLink>
        </div>
        <div
            className="process__description"
            dangerouslySetInnerHTML={{ __html: Autolinker.link(nl2br(process.description)) }}
        />
        {process.telegramLink && (
            <div className="process__link">
                {process.telegramLink && (<a href={process.telegramLink}>Присоединиться к чату</a>)}
                {process.telegramChanelLink && (<a href={process.telegramChanelLink}>Присоединиться к каналу</a>)}
            </div>
        )}
    </div>
)

export default Process
